var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastroFormulario
    ? _c(
        "div",
        [
          _vm.inputsExtraCadastro.georreferencia.texto
            ? _c(
                "el-alert",
                {
                  staticClass: "margin-bottom",
                  attrs: { title: "Atenção", type: "info" }
                },
                [
                  _c("span", [
                    _vm._v("O Georreferenciamento deve ser da área atual")
                  ])
                ]
              )
            : _vm._e(),
          _c("div", [
            _vm.showGeorreferenciamentoOption
              ? _c(
                  "div",
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required",
                        name: "Georreferenciamento/Possui Georreferenciamento'"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label:
                                      "Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?"
                                  }
                                }),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: {
                                      disabled: _vm.isDesable(),
                                      label: "POSSUI"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario
                                          .georreferenciamento
                                          .possuiGeorreferenciamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario
                                            .georreferenciamento,
                                          "possuiGeorreferenciamento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.georreferenciamento.possuiGeorreferenciamento"
                                    }
                                  },
                                  [_vm._v("Sim")]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: {
                                      disabled: _vm.isDesable(),
                                      label: "NAO_POSSUI"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario
                                          .georreferenciamento
                                          .possuiGeorreferenciamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario
                                            .georreferenciamento,
                                          "possuiGeorreferenciamento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.georreferenciamento.possuiGeorreferenciamento"
                                    }
                                  },
                                  [_vm._v("Não")]
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2782575827
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastroFormulario.georreferenciamento
              .possuiGeorreferenciamento === "NAO_POSSUI"
              ? _c(
                  "div",
                  { staticClass: "mapa" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required",
                        name: "Georreferenciamento/Geometria"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("mapa-retificacao", {
                                  attrs: {
                                    localizacoes: _vm.localizacoes,
                                    name: "Geometria",
                                    idMapa: "mapaCadastroGeo",
                                    errors: errors,
                                    addPonto: true
                                  },
                                  model: {
                                    value: _vm.localizacoes,
                                    callback: function($$v) {
                                      _vm.localizacoes = $$v
                                    },
                                    expression: "localizacoes"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        250553795
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastroFormulario.georreferenciamento
              .possuiGeorreferenciamento === "POSSUI"
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "texto-informativo" },
                      [
                        _c(
                          "el-alert",
                          { attrs: { title: "", closable: false } },
                          [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.textGeorreferenciamento)
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c("app-dados-responsavel", {
                      attrs: {
                        responsavel:
                          _vm.cadastroFormulario.georreferenciamento
                            .responsavel,
                        nomeAba: "Georreferenciamento"
                      }
                    }),
                    _c("app-documentos-retificacao", {
                      attrs: {
                        maxSize: 25000,
                        "valid-extensions": _vm.extensoes,
                        documentos: _vm.documentosGeorreferenciamento,
                        tiposDocumentos: _vm.tiposDocumentos,
                        tiposDocumentosObrigatorios: _vm.tiposDocumentos,
                        observer: _vm.observer,
                        pecasTecnicas: true,
                        aba: "Georreferenciamento"
                      },
                      on: {
                        mudaTipo: _vm.mudaTipo,
                        setDadosPlanilha: _vm.setDadosPlanilha,
                        addedDoc: _vm.handleDocs,
                        removedDoc: _vm.removerDocs
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9ca0386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9ca0386","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/GeorreferenciamentoRetificacao.vue
// module id = null
// module chunks = 